<template>
  <div>
    <!-- Button -->
    <v-btn
      :loading="loading"
      :disabled="loading || disabled"
      :small="$vuetify.display.xs"
      color="primary"
      class="mx-0"
      @click="toЕxcel()"
    >
      To Excel
      <v-icon :small="$vuetify.display.xs" :class="{ 'ml-2': $vuetify.display.xs }" right>
        {{ mdiFileExcel }}
      </v-icon>
    </v-btn>

    <!-- Form -->
    <form v-if="modified_criteria" ref="form" :action="normalizedURL" method="POST" @submit.prevent>
      <input :value="JSON.stringify(modified_criteria)" type="hidden" name="criteria" />
    </form>

    <!-- Dialog: Subscription Required -->
    <v-dialog v-model="subscriptionRequiredDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h5"> Subscription Required </v-card-title>
        <v-card-text> A subscription is required to export data to Excel </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text color="primary" @click="subscriptionRequiredDialog = false"> Ok </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// Modules
import { mapStoreState } from '@/store/helpers'
import { mdiFileExcel } from '@mdi/js'
import cloneDeep from 'lodash/cloneDeep'
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    criteria: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    mdiFileExcel,
    subscriptionRequiredDialog: false,
    loading: false,
    modified_criteria: null
  }),

  computed: {
    ...mapStoreState({
      user: state => state.user,
      selectedGroup: state => state.app.selectedGroup
    }),

    normalizedURL() {
      // Prepend `https://whalewisdom.com` to the given url if it's not yet there
      // return 'https://whalewisdom.com' + this.url.replace('https://whalewisdom.com', '')
      return this.url
    }
  },

  methods: {
    toЕxcel() {
      if (!this.user.isSubscriber) {
        this.subscriptionRequiredDialog = true
        return
      }

      this.loading = true

      if (this.criteria) {
        this.modified_criteria = cloneDeep(this.criteria)
        this.modified_criteria.filers = this.selectedGroup.filers
        this.modified_criteria.filer_group_id = this.selectedGroup.id
        this.$nextTick(() => {
          this.$refs.form.submit()
        })
      } else {
        window.location = this.normalizedURL
      }

      this.loading = false
    }
  }
}
</script>
